import axiosInstance from 'src/utils/axios';
import { useQuery } from '@tanstack/react-query';
import { SOCIAL_MANAGER_ACCOUNT_LIST } from 'src/constants/queryKeys';

export const networkCreateSocialManagerAccount = async (socialManagerAccount) => {
  const res = await axiosInstance.post('/SocialManagerAccount/Insert', socialManagerAccount);
  return res;
};

export const networkUpdateSocialManagerAccount = async (id, socialManagerAccount) => {
  const res = await axiosInstance.post(`/SocialManagerAccount/Update/${id}`, socialManagerAccount);
  return res;
};

export const networkRemoveSocialManagerAccount = async (id) => {
  const res = await axiosInstance.post(`/SocialManagerAccount/Remove/${id}`);
  return res;
};

export const networkInfoSocialManagerAccount = async (id) => {
  const res = await axiosInstance.post(`/SocialManagerAccount/Info/${id}`);
  return res;
};

export const networkGetListSocialManagerAccount = async (payload, pageIndex, pageSize) => {
  const res = await axiosInstance.post(`/SocialManagerAccount/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchSocialManagerAccountList(payload, pageIndex = 0, pageSize = 50) {
  return useQuery({
    queryKey: [SOCIAL_MANAGER_ACCOUNT_LIST, pageIndex, pageSize],
    queryFn: () => networkGetListSocialManagerAccount(payload, pageIndex, pageSize),
  });
}

export const networkGetSocialManagerAccountTypeList = async (payload, pageIndex, pageSize = 50) => {
  const res = await axiosInstance.post(`/SocialManagerAccountType/List/${pageIndex}/${pageSize}`, payload);
  return res;
};

export function useFetchSocialManagerAccountTypeList(payload, pageIndex, pageSize=50) {
  return useQuery({
    queryKey: ['social-manager-account-type-List',payload],
    queryFn: () => networkGetSocialManagerAccountTypeList(payload, pageIndex, pageSize),
  });
}
